import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteAuthorizedSignerMutationVariables = Types.Exact<{
  authorized_signer_id: Types.Scalars['ID'];
}>;


export type DeleteAuthorizedSignerMutation = { __typename?: 'Mutation', deleteAuthorizedSigner: string };


export const DeleteAuthorizedSignerDocument = gql`
    mutation DeleteAuthorizedSigner($authorized_signer_id: ID!) {
  deleteAuthorizedSigner(authorized_signer_id: $authorized_signer_id)
}
    `;
export type DeleteAuthorizedSignerMutationFn = Apollo.MutationFunction<DeleteAuthorizedSignerMutation, DeleteAuthorizedSignerMutationVariables>;

/**
 * __useDeleteAuthorizedSignerMutation__
 *
 * To run a mutation, you first call `useDeleteAuthorizedSignerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthorizedSignerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuthorizedSignerMutation, { data, loading, error }] = useDeleteAuthorizedSignerMutation({
 *   variables: {
 *      authorized_signer_id: // value for 'authorized_signer_id'
 *   },
 * });
 */
export function useDeleteAuthorizedSignerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAuthorizedSignerMutation, DeleteAuthorizedSignerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAuthorizedSignerMutation, DeleteAuthorizedSignerMutationVariables>(DeleteAuthorizedSignerDocument, options);
      }
export type DeleteAuthorizedSignerMutationHookResult = ReturnType<typeof useDeleteAuthorizedSignerMutation>;
export type DeleteAuthorizedSignerMutationResult = Apollo.MutationResult<DeleteAuthorizedSignerMutation>;
export type DeleteAuthorizedSignerMutationOptions = Apollo.BaseMutationOptions<DeleteAuthorizedSignerMutation, DeleteAuthorizedSignerMutationVariables>;